<template>
    <div>
     <b-modal size="lg" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="marsModal" @close="this.emitEventCancel" @ok="this.emitEventOK" ok-only :ok-title="$t('Shared.Close')" > 
        
        <MarsView 
                v-bind:OpenInModal="true" 
                v-bind:PCode="this.PatientCode" 
                v-bind:DFrom="this.DateFrom"
                v-bind:DTo="this.DateTo"
                v-bind:PObj="this.PhotoObj">
        </MarsView>
       
     </b-modal>  
    </div>
</template>
 
 <script>


import MarsView from '@/components/pages/nurses/mars/Mars.vue'

 export default {  
   name: 'MarsModal',
   props: {
     ModalId: String,
     TitleWindow: String,
     PatientCode:String,
     DateFrom:String,
     DateTo:String,  
     PhotoObj:Object,  
   },

   components:{MarsView},
   
   data(){
     return {

     }
        
   },
 
   methods:{ 
    emitEventCancel(event){
        if (this.pendingChanges) {
            event.preventDefault();
            this.handleVerifyAndClose();
        } else {
            this.$emit('ModalTPMarsMed');
        }
    },

     emitEventOK(event){
        if (this.pendingChanges) {
            event.preventDefault();
            this.handleVerifyAndClose();
        } else {
            this.$emit('ModalTPMarsMed');
        }
    },
   },

   created(){

   },
 
  mounted(){
  

   },
 };
</script>
